import { useCallback, useMemo } from 'react';
import { bindActionCreators } from '@reduxjs/toolkit';

import { useAppDispatch, useAppSelector } from '#apps/client-web/app/store';
import { actions } from '#apps/client-web/app/store/drawer.slice';

export const useDrawer = () => {
  const dispatch = useAppDispatch();
  const drawerState = useAppSelector((state) => state.drawer.state);

  const { open, close } = useMemo(
    () => bindActionCreators(actions, dispatch),
    [dispatch],
  );

  const openCallback = useCallback(() => open(), [open]);
  const closeCallback = useCallback(() => close(), [close]);

  return {
    open: openCallback,
    close: closeCallback,

    state: drawerState,
    isOpen: drawerState === 'open',
    isClosed: drawerState === 'closed',
  };
};
